export default __webpack_public_path__ + "static/media/A2.57e79a7f.png";